import React, { createContext, useContext, useState } from "react";

const TableCacheContext = createContext();

export const TableCacheProvider = ({ children }) => {
  const [cache, setCache] = useState({}); // { [cacheKey]: { data, total } }

  const updateCache = (key, value) => {
    setCache((prev) => ({ ...prev, [key]: value }));
  };

  return (
    <TableCacheContext.Provider value={{ cache, updateCache }}>
      {children}
    </TableCacheContext.Provider>
  );
};

export const useTableCache = () => useContext(TableCacheContext);
